import * as t from 'io-ts';

import {RSubscribeToConversationTask} from './subscribeToConversationTask';
import {RUpdateConversationsSeenTask} from './updateConversationsSeenTask';
import {RUpdateConversationsTrackerStatusTask} from './updateConversationsTrackerStatusTask';

export type ConversationsTask =
  | t.TypeOf<typeof RSubscribeToConversationTask>
  | t.TypeOf<typeof RUpdateConversationsSeenTask>
  | t.TypeOf<typeof RUpdateConversationsTrackerStatusTask>;

export const RConversationsTask = t.taggedUnion('name', [
  RSubscribeToConversationTask,
  RUpdateConversationsSeenTask,
  RUpdateConversationsTrackerStatusTask,
]);
